// extracted by mini-css-extract-plugin
export default {"sale":"Sale_sale__ASsN4","body":"Sale_body__03mMn","dropdowns":"Sale_dropdowns__pj01P"};